import * as Yup from 'yup';
import { DataLists } from 'services/data/data.types';
import { FormErrorMessages } from 'utils/formValidation';

export type UserAppointmentFormSchemaProps = {
    datalists: DataLists;
};

export const UserAppointmentFormSchema = (datalists: DataLists) => {
    return Yup.object().shape({
        label: Yup.string().required(FormErrorMessages.required),
        observation: Yup.string().required(FormErrorMessages.required),
        started_at: Yup.date().required(FormErrorMessages.required),
        ended_at: Yup.date().required(FormErrorMessages.required),
        communication_type: Yup.string()
            .oneOf(Object.keys(datalists?.communication_types || {}), FormErrorMessages.communication_type_invalid)
            .required(FormErrorMessages.required)
    });
};
